import { create } from '@thoughtspot/logger';
const logger = create('url-query-params');
export const MASK_TEXT = 'MASKED';
export const urlQueryParams = {
    query: { name: 'query', isSensitive: true },
    suggestedQuestionId: { name: 'suggestedQuestionId', isSensitive: true },
    eurekaQuery: { name: 'eurekaQuery', isSensitive: true },
    author: { name: 'author', isSensitive: false },
    tag: { name: 'tag', isSensitive: false },
    worksheet: { name: 'worksheet', isSensitive: false },
    page: { name: 'page', isSensitive: false },
    offset: { name: 'offset', isSensitive: false },
    sortOnType: { name: 'sortOnType', isSensitive: false },
    sortOrder: { name: 'sortOrder', isSensitive: false },
    type: { name: 'type', isSensitive: false },
    enableGeomapDblClickZoom: {
        name: 'enableGeomapDblClickZoom',
        isSensitive: false,
    },
    enableDoubleClickDrillDown: {
        name: 'enableDoubleClickDrillDown',
        isSensitive: false,
    },
    dataSourceMode: { name: 'dataSourceMode', isSensitive: false },
    useLastSelectedSources: {
        name: 'useLastSelectedSources',
        isSensitive: false,
    },
    hostAppUrl: { name: 'hostAppUrl', isSensitive: false },
    viewPortHeight: { name: 'viewPortHeight', isSensitive: false },
    viewPortWidth: { name: 'viewPortWidth', isSensitive: false },
    sdkVersion: { name: 'sdkVersion', isSensitive: false },
    isAnswerV2Enabled: { name: 'isAnswerV2Enabled', isSensitive: false },
    isPinboardV2Enabled: { name: 'isPinboardV2Enabled', isSensitive: false },
    isPinboardV2TabsEnabled: {
        name: 'isPinboardV2TabsEnabled',
        isSensitive: false,
    },
    isSpotIQV2Enabled: { name: 'isSpotIQV2Enabled', isSensitive: false },
    debug: { name: 'debug', isSensitive: false },
    disableTransformationsInVizEmbeds: {
        name: 'disableTransformationsInVizEmbeds',
        isSensitive: false,
    },
    instantSearch: { name: 'instantSearch', isSensitive: false },
    enableParameters: { name: 'enableParameters', isSensitive: false },
    enableCohorts: { name: 'enableCohorts', isSensitive: false },
    showAutoGeneratedFormulas: {
        name: 'showAutoGeneratedFormulas',
        isSensitive: false,
    },
    locale: { name: 'locale', isSensitive: false },
    clientLogLevel: { name: 'clientLogLevel', isSensitive: false },
    isColumnSummariesEnabledByDefault: {
        name: 'isColumnSummariesEnabledByDefault',
        isSensitive: false,
    },
    hideAction: { name: 'hideAction', isSensitive: false },
    isSearchEmbed: { name: 'isSearchEmbed', isSensitive: false },
    embedApp: { name: 'embedApp', isSensitive: false },
    isLiveboardEmbed: { name: 'isLiveboardEmbed', isSensitive: false },
    isSageEmbed: { name: 'isSageEmbed', isSensitive: false },
    hideWorksheetSelector: {
        name: 'hideWorksheetSelector',
        isSensitive: false,
    },
    disableWorksheetChange: {
        name: 'hideWorksheetSelector',
        isSensitive: false,
    },
    hideEurekaResults: { name: 'hideEurekaResults', isSensitive: false },
    primaryNavHidden: { name: 'primaryNavHidden', isSensitive: false },
    profileAndHelpInNavBarHidden: {
        name: 'profileAndHelpInNavBarHidden',
        isSensitive: false,
    },
    disableLoginRedirect: { name: 'disableLoginRedirect', isSensitive: false },
    apiResourceId: { name: 'apiResourceId', isSensitive: false },
    isRAnalysisEnabled: { name: 'isRAnalysisEnabled', isSensitive: false },
    enableCustomCharts: { name: 'enableCustomCharts', isSensitive: false },
    skipClientStateSchemaCheck: {
        name: 'skipClientStateSchemaCheck',
        isSensitive: false,
    },
    source: {
        name: 'source',
        isSensitive: false,
        description: 'Eureka Search source',
        dataType: 'string',
    },
    worksheetId: {
        name: 'worksheetId',
        isSensitive: false,
        description: 'Eureka worksheet selection Id',
        dataType: 'string',
    },
    eurekaRequestId: {
        name: 'eurekaRequestId',
        isSensitive: false,
        description: 'Eureka SRP AI answer session Id',
        dataType: 'string',
    },
    eurekaAnswerAcSessionId: {
        name: 'eurekaAnswerAcSessionId',
        isSensitive: false,
        description: 'Eureka SRP AI answer ac session Id',
        dataType: 'string',
    },
    feedbackMode: {
        name: 'feedbackMode',
        isSensitive: false,
        description: 'Eureka SRP AI answer feedback mode',
        dataType: 'boolean',
    },
    loadEvent: {
        name: 'loadEvent',
        isSensitive: false,
        description: 'mix panel tracking event',
        dataType: 'string',
    },
    eurekaUrl: {
        name: 'eurekaUrl',
        isSensitive: true,
        description: 'Eureka search url used for redirecting the user from fullscreen view new tab back to the Eureka SRP',
        dataType: 'string',
    },
    isFalcon: {
        name: 'isFalcon',
        isSensitive: false,
        description: 'Flag to indicate if the import csv page should use falcon or embrace',
        dataType: 'boolean',
    },
    origin: {
        name: 'origin',
        isSensitive: false,
        description: 'Origin of the import csv page',
        dataType: 'string',
    },
    isTooltipCustomizationEnabled: {
        name: 'isTooltipCustomizationEnabled',
        isSensitive: false,
        description: 'Feature flag to enable adding extra columns from answer to tootip',
        dataType: 'boolean',
    },
    isEnhancedCfEnabled: {
        name: 'isEnhancedCfEnabled',
        isSensitive: false,
        description: 'Feature flag to enable enhanced conditional formatting',
        dataType: 'boolean',
    },
    customNumberFormatPatternForGeoChart: {
        name: 'customNumberFormatPatternForGeoChart',
        isSensitive: false,
        description: 'custom number format pattern to override all format patterns applied only for geo charts',
        dataType: 'string',
    },
    gitIntegration: {
        name: 'gitIntegration',
        isSensitive: false,
        description: 'Feature flag to enable git integration',
        dataType: 'boolean',
    },
    enableVcsUI: {
        name: 'enableVcsUI',
        isSensitive: false,
        description: 'Feature flag to enable vcs ui',
        dataType: 'boolean',
    },
    isVersionHistoryEnabled: {
        name: 'isVersionHistoryEnabled',
        isSensitive: false,
        description: 'Feature flag to enable version history',
        dataType: 'boolean',
    },
};
function maskUrlSearchParams(urlSearchParams) {
    urlSearchParams.forEach((_v, paramKey) => {
        if (!urlQueryParams[paramKey]) {
            logger.warn(`Unrecognized query param detected - ${paramKey}. Please add to urlQueryParams map in env-flags.`);
        }
        if (urlQueryParams[paramKey]?.isSensitive) {
            urlSearchParams.set(paramKey, MASK_TEXT);
        }
    });
    return decodeURIComponent(urlSearchParams.toString());
}
export function maskQueryParamsOnUrl(url) {
    const urlObj = new URL(url);
    const searchParams = new URLSearchParams(urlObj.search);
    const onlyHash = urlObj.hash.split('?')[0];
    const queryParamsInHash = new URLSearchParams(urlObj.hash.split('?')[1]);
    const searchStr = maskUrlSearchParams(searchParams);
    const queryStrInHash = maskUrlSearchParams(queryParamsInHash);
    urlObj.search = searchStr;
    if (onlyHash && queryStrInHash)
        urlObj.hash = `${onlyHash}?${queryStrInHash}`;
    return decodeURIComponent(urlObj.toString());
}
export function maskQueryParamsOnRelativePath(relativePath) {
    const [onlyPath, searchStr] = relativePath.split('?');
    const searchParams = new URLSearchParams(searchStr);
    const maskedSearchStr = maskUrlSearchParams(searchParams);
    return maskedSearchStr ? `${onlyPath}?${maskedSearchStr}` : onlyPath;
}
//# sourceMappingURL=url-query-param.js.map